module.exports = __webpack_public_path__ + "img/top_reight.86761295.svg";